export const REFERRAL_ID_KEY = 'referralId'
export const ADDRESS_KEY = 'address'
export const LOCAL_STORAGE_BANK_ID_TOKEN_KEY = 'bankIdToken'
